import cn from "@/util/cn"

const Skeleton = ({ className }: { className?: string }) => (
  <div
    className={cn("animate-pulse rounded-md bg-primary-contrast/10", className)}
  />
)

export { Skeleton }
